module.exports = __webpack_public_path__ + "img/attack.ddf681f3.svg";